import SacHorarioAtendimento from './components/sacHorarioAtendimento'

type SacHorariosAtendimentoProps = {
  horarioAtendimentoDiasUteisInicio?: string
  horarioAtendimentoDiasUteisFim?: string
  horarioAtendimentoSabadoInicio?: string
  horarioAtendimentoSabadoFim?: string
  horarioAtendimentoDomingoInicio?: string
  horarioAtendimentoDomingoFim?: string
}

export default function SacHorariosAtendimento({
  horarioAtendimentoDiasUteisInicio,
  horarioAtendimentoDiasUteisFim,
  horarioAtendimentoSabadoInicio,
  horarioAtendimentoSabadoFim,
  horarioAtendimentoDomingoInicio,
  horarioAtendimentoDomingoFim,
}: SacHorariosAtendimentoProps) {
  return (
    <>
      <SacHorarioAtendimento
        prefixo={'Segunda a sexta'}
        horarioAtendimentoInicio={horarioAtendimentoDiasUteisInicio}
        horarioAtendimentoFim={horarioAtendimentoDiasUteisFim}
        exibirHorarioAtendimento={Boolean(
          horarioAtendimentoDiasUteisInicio && horarioAtendimentoDiasUteisFim
        )}
      ></SacHorarioAtendimento>
      <SacHorarioAtendimento
        prefixo={'Sábado'}
        horarioAtendimentoInicio={horarioAtendimentoSabadoInicio}
        horarioAtendimentoFim={horarioAtendimentoSabadoFim}
        exibirHorarioAtendimento={Boolean(
          horarioAtendimentoSabadoInicio && horarioAtendimentoSabadoFim
        )}
      ></SacHorarioAtendimento>
      <SacHorarioAtendimento
        prefixo={'Domingo e feriados'}
        horarioAtendimentoInicio={horarioAtendimentoDomingoInicio}
        horarioAtendimentoFim={horarioAtendimentoDomingoFim}
        exibirHorarioAtendimento={Boolean(
          horarioAtendimentoDomingoInicio && horarioAtendimentoDomingoFim
        )}
      ></SacHorarioAtendimento>
    </>
  )
}
